@if (isAdvancedSearchApplied()) {
  <app-context-menu-item
    [withCheckOption]="true"
    [close]="true"
    title="All results"
  icon="sapphire-search"
    [active]="filterKey === 'search_results'"
    (execute)="selectFilter('search_results')"
  />
}

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Contacts"
  icon="sapphire-contact"
  [active]="filterKey === 'all_contacts'"
  (execute)="selectFilter('all_contacts')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="VIP"
  icon="sapphire-vip"
  [active]="filterKey === 'vip'"
  (execute)="selectFilter('vip')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Flagged"
  icon="sapphire-flagged"
  [active]="filterKey === 'flagged'"
  (execute)="selectFilter('flagged')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Follow Up"
  icon="sapphire-follow-up"
  [active]="filterKey === 'followed'"
  (execute)="selectFilter('followed')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Snoozed"
  icon="sapphire-snooze"
  [active]="filterKey === 'snoozed'"
  (execute)="selectFilter('snoozed')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Archive"
  icon="sapphire-archive"
  [active]="filterKey === 'archived'"
  (execute)="selectFilter('archived')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Trash"
  icon="sapphire-trash"
  [active]="filterKey === 'deleted'"
  (execute)="selectFilter('deleted')"
/>

<app-context-menu-item
  [withCheckOption]="true"
  [close]="true"
  title="Groups"
  icon="sapphire-groups"
  [active]="filterKey === 'all_groups'"
  (execute)="selectFilter('all_groups')"
/>
